import React from 'react';
import styled from 'styled-components';
import { flex } from '../../../styles/utilities/flex';
import MaterialIcon from '../../../shared/common/MaterialIcon';

const StLi = styled.li<{ bold?: boolean }>`
    ${flex('row')};
    align-items: center;
    font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;

const StLiValue = styled.span`
    margin-right: 3px;
`;

StLiValue.displayName = 'LCFormFieldValueList__StLiValue';

interface ListItem<T> {
    id: T;
    name: string;
}

interface Props<T> {
    value: ListItem<T>[];
    bold?: boolean;
    editable?: boolean;
    onRemove?: (value: T, index: number) => void;
}

export function LCFormFieldValueList<T>({ bold, editable, onRemove = () => {}, value }: Props<T>) {
    return (
        <ul data-testid="value-list">
            {value.map((currentValue, index) => (
                <StLi key={`selected-genres-${index}`} bold={bold}>
                    <StLiValue>{currentValue.name}</StLiValue>
                    {editable ? (
                        <MaterialIcon primary={true} icon="delete" onClick={() => onRemove(currentValue.id, index)} />
                    ) : null}
                </StLi>
            ))}
        </ul>
    );
}
